import { useEffect } from 'react';

export function useScrollToTop() {
    const pathname = window.location.pathname;

    // biome-ignore lint/correctness/useExhaustiveDependencies: intended, run on location update
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
}
